export default __webpack_public_path__ + "static/media/trash-2.c4910e89.svg";